import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SignInDialogComponent } from '@mp-app/modules/landing/containers/landing-auth/sign-in-dialog/sign-in-dialog.component';
import { AuthService } from '@mp-core/services/auth.service';

@Component({
  selector: 'mp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {

  @Input() isUserAuthenticated: boolean = false;

  constructor(private matDialog: MatDialog, private authService: AuthService) {
  }

  openSignInDialog(): void {
    this.matDialog.open(SignInDialogComponent, {
      minWidth: '30%',
    });
  }

  logout(): void {
    this.authService.logout();
  }
}
